import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, HostBinding, OnInit } from '@angular/core';
import { TraducaoService } from '../../services/traducao.service';
import { ContainerBotaoComponent } from '../container-botao/container-botao.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-formacao',
  standalone: true,
  imports: [
    ContainerBotaoComponent,
    CommonModule
  ],
  templateUrl: './formacao.component.html',
  styleUrls: ['./formacao.component.css']
})
export class FormacaoComponent implements OnInit {
  formacao: string = '';
  idiomas: string = '';
  extraCurso: string = '';

  superiorAtual: string = '';
  superiorAnterior: string = '';

  espanholNivel: string = '';
  inglesNivel: string = '';

  extra1: string = '';
  extra2: string = '';
  extra3: string = '';
  extra4: string = '';
  extra5: string = '';
  extra6: string = '';

  @Input() isScrollAtTop: boolean = true;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;

  @Output() voltarHome: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding('class.show') show: boolean = false;

  extra: { nome: string; instituicao: string; status: string; cargaHoraria: string }[] = [
    {
      nome: 'Cenografia e Ambientação',
      instituicao: 'CC San Martín/ARG',
      status: 'Concluído',
      cargaHoraria: '70 horas'
    },
    {
      nome: 'Fotografía e Edição Básica',
      instituicao: 'CC San Martín/ARG',
      status: 'Concluído',
      cargaHoraria: '70 horas'
    },
    {
      nome: 'Desenho de Cenografia',
      instituicao: 'Inst. Saulo Benavente/ARG',
      status: 'Concluído',
      cargaHoraria: '120 horas'
    },
    {
      nome: 'Introdução a Direção de Arte',
      instituicao: 'Cistik Oficina/ARG',
      status: 'Concluído',
      cargaHoraria: '16 horas'
    },
    {
      nome: 'Desenho de Croquis',
      instituicao: 'Centro FD',
      status: 'Concluído',
      cargaHoraria: '50 horas'
    },
    {
      nome: 'Introdução a Roteiro Audiovisual',
      instituicao: 'ACM',
      status: 'Concluído',
      cargaHoraria: '36 horas'
    }
  ];

  private translationKeys: string[] = ['formacao', 'idiomas', 'extraCurso', 'superiorAtual', 'superiorAnterior',
    'espanholNivel', 'inglesNivel', 'extra1', 'extra2', 'extra3', 'extra4', 'extra5', 'extra6'];

  constructor(private traducaoService: TraducaoService) {
  }

  ngOnInit(): void {
    this.translationKeys.forEach(key => this.obterTraducao(key));
    setTimeout((): void => {
      this.show = true;
    }, 100);
  }

  private obterTraducao(key: string): void {
    this.traducaoService.obterTraducao(key).subscribe({
      next: (traducao) => {
        (this as any)[key] = traducao;
      },
      error: (error) => console.error(`Erro ao obter tradução para ${key}:`, error)
    });
  }

  onVoltarHome(): void {
    this.voltarHome.emit();
  }

  onScroll(): void {
    if (this.scrollContainer) {
      const scrollTop: number = this.scrollContainer.nativeElement.scrollTop;
      this.isScrollAtTop = scrollTop === 0;
    }
  }

  scrollToTop(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      const scrollElement: HTMLElement = this.scrollContainer.nativeElement;
      scrollElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  navegarParaTag(tag: string): void {
    const element: HTMLElement | null = document.getElementById(tag);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
